<app-multiselect-dropdown
    class="filter"
    [formControl]="control" 
    [label]="label"
    [id]="'schedules'"
    [placeholder]="'All Schedules'"
    [data]="schedulesList"
    [settings]="schedulesListSettings"
    [itemsLimit]="selectedItemsBadgeLimitCount"
    [dropdownListPaddingTop]="0"
    #schedulesMultiselectDropdown
></app-multiselect-dropdown>
